import { ANALYSIS_CLOSE_ALL_MODALS, ANALYSIS_OPEN_EDIT_MODAL } from './reducer';

export const closeAllAnalysisModals = () => {
  return {
    type: ANALYSIS_CLOSE_ALL_MODALS
  };
};

export const openEditModal = projectId => {
  return {
    type: ANALYSIS_OPEN_EDIT_MODAL,
    projectId
  };
};



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/ProjectList/modalActions.js